// @ts-check
import 'Styles/userSettings/userDlSetting.scss';
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * canDelete: boolean,
 * doDelete: () => void,
 * dlInfo: WebUserDL,
 * }} props 
 * @returns {React.JSX.Element}
 */
const UserDlSetting = (props) => {
    const status = props.dlInfo.isStatusDeleting
        ? "Данные находятся в процессе удаления..."
        : props.dlInfo.isCancelled
            ? "Синхронизация не завершена"
            : props.dlInfo.isSynced
                ? "Синхронизирован"
                : "Не синхронизирован";

    return (
        <div className={'userdl-setting'}>

            <div className='userdl-setting-title'>
                <span className='asistent-setting-title-name'>
                    <span className='asistent-setting-title-name-value'>{props.dlInfo.title}</span>
                    {props.dlInfo.isMain ? (<b>&nbsp;(основной)</b>) : (<b>&nbsp;(вспомогательный)</b>)}
                </span>
                <span className={props.dlInfo.isStatusError ? "asistent-setting-status-red" : "asistent-setting-status-green"}>
                    {status}
                </span>
            </div>

            {
                props.dlInfo.isCanDelete != true ? '' :
                    <div className='userdl-setting-buttons'>
                        <button
                            id={`userdl-setting-delete-button-${props.dlInfo.contactLid}`}
                            onClick={props.doDelete}
                            className={'red-button ' + (!props.canDelete ? 'disabled' : '')}>
                            Удалить
                        </button>
                    </div>
            }
        </div>
    )
}

export default observer(UserDlSetting);